import React from 'react';
import { useHistory, useMatch } from 'app/hooks/index';
import StoryOptions from 'stories/options/index';

const CollectionStoryOptions = () => {
  const { replace } = useHistory();
  const {
    params: { id, type, storyId },
  } = useMatch();
  return <StoryOptions storyId={storyId} onClose={() => replace(`/${type}/${id}`)} />;
};

CollectionStoryOptions.propTypes = {};

export default CollectionStoryOptions;
